import { render, staticRenderFns } from "./AllVendorsList.vue?vue&type=template&id=28d558f9&scoped=true&"
import script from "./AllVendorsList.vue?vue&type=script&lang=js&"
export * from "./AllVendorsList.vue?vue&type=script&lang=js&"
import style0 from "./AllVendorsList.vue?vue&type=style&index=0&id=28d558f9&lang=scss&scoped=true&"
import style1 from "./AllVendorsList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./AllVendorsList.vue?vue&type=style&index=2&id=28d558f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d558f9",
  null
  
)

export default component.exports